import { useState } from 'react';
import ReusableDataTable from '../../components/ReusableDataTable';
// import CertificateDetails from './certificate_details';
import BackdropModal from '../../components/modals/backdrop_modal';
import apiRequest from '../../services/apiService';
import UserDetails from './user_details';

const pk = "cert_id";

const columns = [
    { id: 'id',             field: 'user_profile_id',headerName: 'PROFILE' },
    { id: 'fullname',       field: 'fullname',      headerName: 'Fullname' },
    { id: 'email_address',  field: 'email_address', headerName: 'Email' },
    { id: 'date_created',  field: 'date_created', headerName: 'Created' },
    { id: 'user_status',  field: 'user_status', headerName: 'Status' },
];


// List of fields that are date fields
const columns_date = ['date_created'];


// List of fields that has status
const columns_status = ['user_status'];


const actions = [
    { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },
];

const other_actions = [
     { label: 'Activate', link: '/delete', icon: 'bx bx-detail me-1' },
];

const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm }) => {
    const params = {
        page     : page,
        page_size: rowsPerPage,
        ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
        search   : searchTerm || undefined,
    };

    return await apiRequest('GET', '/appusers/', null, params);
};



const UserTable = () => {

    const deleteEndpoint = `${process.env.REACT_APP_API_URL}/appusers`;
    const [selectedItem, setSelectedItem] = useState(null);

    const handleViewDetails = (item) => {
        console.log(item);
        setSelectedItem(item);
        setOpen(true);
    };

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        handleClose();
    };


    const handleActivate = (row,todo) => {
        console.log(row);
     }


     const getStatusWithColor = (column, value) => {
        if (columns_status.includes(column)) {
            const statusColors = {
                activated  : 'badge bg-label-success',
                pending    : 'badge bg-label-warning',
                deactivated: 'badge bg-label-danger',
            };

         
            const color = statusColors[value] || 'white';
            return (
                <span className={color}>
                    {value}
                </span>
            );
        }
        return value; // For other columns, return the value as is
    };


    const generateRowActions = (row) => {
        let button_title="";

        if(row.user_status.toLowerCase() === "activated"){
            button_title="Deactivate";
        }
        else if(row.user_status.toLowerCase() === "deactivated"){
            button_title="Activate";
        }
        else if(row.user_status.toLowerCase() === "pending"){
            button_title="Approve";
        }
        else{
            button_title="";
        }


        return (
            button_title &&
                <div>
                    <button className='dropdown-item' onClick={() => handleActivate(row)}><i className='bx bx-detail me-1'></i>{button_title} Account</button>
                </div>
        );
    };

    return (
        <>
            <ReusableDataTable
                fetchDataFn    = {fetchData}
                columns        = {columns}
                
                actions        = {actions}
                // other_actions  = {generateRowActions}
                other_actions  = ""

                onViewDetails  = {handleViewDetails}
                deleteEndpoint = {deleteEndpoint}
                tableTitle     = 'List of Transactions'
                primarykey     = {pk}
                handleActivate={handleActivate}

                columns_date   = {columns_date}
                cellStylingFn={getStatusWithColor}
            />

            <BackdropModal open={open} handleClose={handleClose} handleSave={handleSave} modalTitle="User Details" >
                <UserDetails selectedItem={selectedItem} />
            </BackdropModal>
        </>
    );
}

export default UserTable;